<!-- Subtabla Confecciones -->
<table>
    <thead>
        <tr>
            <th class="date sortable" (click)="toOrderBy('x=> x.Consumo.FechaIns', 'fechaConfeccion')">
                {{ 'global.fecha.confeccion' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('fechaConfeccion')"></i>
                </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.Consumo.Lote', 'lote')">
                {{ 'global.lote' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('lote')"></i>
                </div>
            </th>
            <th class="string">
                {{ 'global.finca' | translate }}
            </th>
            <th class="string sortable" (click)="toOrderBy('x => x.Consumo.ConsumosDetalle.Select(y => y.Designacion.Cultivo.Finca.Municipio.Provincia).OrderBy(y => y.Des).FirstOrDefault().Des', 'provincia')">
                {{ 'global.provincia' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('provincia')"></i>
                </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.Consumo.ConsumosDetalle.Select(y => y.Designacion.Cultivo.Finca.Municipio).OrderBy(y => y.Des).FirstOrDefault().Des', 'municipio')">
                {{ 'global.municipio' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('municipio')"></i>
                </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.Consumo.ConsumosDetalle.SelectMany(y => y.Designacion.Cultivo.CultivosProductor.Select(z => z.Productor)).OrderBy(y => y.Des).FirstOrDefault().Des', 'productor')">
                {{ 'global.productor' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('productor')"></i>
                </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.Consumo.Confeccion.Des', 'confeccion')">
                {{ 'global.confeccion' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('confeccion')"></i>
                </div>
            </th>
            <th class="string">
                {{ 'global.type' | translate }}
            </th>
            <th class="number sortable" (click)="toOrderBy('x=> x.Unidades', 'unidades')">
                {{ 'global.unidades' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('unidades')"></i>
                </div>
            </th>
            <th class="actions"></th>
        </tr>
    </thead>
    <tbody *ngFor="let confeccion of confecciones; let i = index; trackBy: trackByConfeccionId">
        <tr>
            <td class="date">{{ confeccion.fechaConfeccion | date: 'shortDate' : undefined : defaultLanguage }}</td>
            <td class="string">{{ confeccion.lote }}</td>
            <td class="string">{{ confeccion.desFinca }}</td>
            <td class="string">{{ confeccion.desProvincia }}</td>
            <td class="string">{{ confeccion.desMunicipio }}</td>
            <td class="string">{{ confeccion.desProductor }}</td>
            <td class="string">{{ confeccion.desConfeccion }}</td>
            <td class="string">{{ confeccion.tipoConfeccionId === 1 ? ('global.caja' | translate) : 
                confeccion.tipoConfeccionId === 2 ? ('global.pallet' | translate) : '' }}</td>
            <td class="number">{{ confeccion.unidades | number : '1.0-0': defaultLanguage }}</td>
            <td class="actions"></td>
        </tr>
    </tbody>
    <tfoot *ngIf="(!confecciones || (confecciones && confecciones.length < 1))">
        <tr>
            <td colspan="10">
                {{ 'global.noContent' | translate }}
            </td>
        </tr>
    </tfoot>
</table>

<app-paginator 
    *ngIf="confecciones && confecciones.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
    [totalItems]="totalItems" [visiblePages]="visiblePages" 
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>

<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>